import { Component, Mixins } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import Language from '@/views/Authentication/components/language/language.vue'

@Component({
    components: { Language },
})
export default class Authentication extends Mixins<MixinInterface>() {}
